module.exports = __webpack_public_path__ + "static/media/uiux-designing.ffaed590.png";